
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Redirect } from "@/types/redirectTypes";

interface DeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  redirect: Redirect | null;
  onConfirm: () => void;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({
  open,
  onOpenChange,
  redirect,
  onConfirm,
}) => {
  if (!redirect) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Redirect</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the redirect from{" "}
            <code className="text-red-500">{redirect.source_path}</code> to{" "}
            <code>{redirect.target_path}</code>?
            <br />
            <br />
            This action cannot be undone. Links to the source URL will stop working
            if this is the only redirect for this path.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-red-500 hover:bg-red-600">
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteDialog;
